import configs from '../constants/config';
import axios from 'axios';

class OtpService {
  baseURL = configs.api_base_url;

  isOtpEnabled(applicationID) {
    return axios.get(`${this.baseURL}/otp/${applicationID}`);
  }

  getTokenId(applicationID) {
    // Sent without a body. axios <0.27 always set this Content-Type on bodyless
    // POSTs; 0.27 stopped doing so when `data` is undefined. Set it explicitly to
    // keep the request on the wire identical to axios 0.21 and avoid a 415.
    return axios.post(`${this.baseURL}/otp/${applicationID}`, undefined, {
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  verifyOtpCode(applicationID, data) {
    return axios.post(`${this.baseURL}/otp/${applicationID}/verify`, data);
  }
}

const otp = new OtpService();

export default otp;
